export default __webpack_public_path__ + "static/media/office2-afterB-1440w.3e9fe557.avif";